/**
 * Configuración central de CTAs y texto de conversión. FUENTE ÚNICA del URL del
 * calendario (`demoCTA.url`, con fallback): cambiarlo aquí propaga a todos los CTAs
 * de demo del sitio — Navbar, Hero, CTAStrip, los *CTA/*Hero de cada página
 * (casos, metodología, tecnología, planes, contacto), ResultsSection, y
 * plans.js / addons.js.
 *
 * Nota: cta.js es ESM puro (solo usa process.env). Al importarlo desde archivos que
 * next.config.mjs carga vía Node ESM (plans.js, addons.js) usar la ruta CON extensión
 * (`'../cta.js'`), porque Node ESM no infiere `.js` como webpack.
 */

export const demoCTA = {
  url:
    process.env.NEXT_PUBLIC_CALENDAR_URL ||
    'https://calendar.app.google/a4mBs5LpWy9oQFe88',
  label: 'Agendar demo',
  gtmEvent: 'demo_request',
  target: '_blank',
  rel: 'noopener noreferrer',
};

export const ctaStrip = {
  eyebrow: 'Comenzar',
  title: 'Tu competencia ya está en ChatGPT y Gemini.',
  titleAccent: '¿Y tú?',
  primary: demoCTA,
};
